/* DHC v1052.26 — final theme infrastructure guardrails */
(function(){
  'use strict';
  function qs(s,r){return (r||document).querySelector(s)}
  function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  function cart(){return qs('[data-cart-drawer]')}
  function jack(){return qs('[data-dhc-support], .dhc-support-widget')}

  function hardenExternalLinks(){
    qsa('a[target="_blank"]').forEach(function(a){
      var rel=(a.getAttribute('rel')||'').split(/\s+/).filter(Boolean);
      ['noopener','noreferrer'].forEach(function(v){if(rel.indexOf(v)<0)rel.push(v)});
      a.setAttribute('rel',rel.join(' '));
    });
  }

  function syncPanels(){
    var c=cart(), j=jack();
    var cartOpen=!!(c&&(c.classList.contains('is-open')||c.getAttribute('aria-hidden')==='false'));
    document.documentElement.classList.toggle('dhc-cart-open',cartOpen);
    document.body.classList.toggle('dhc-cart-open',cartOpen);
    if(cartOpen && j){
      try{if(window.DHCCloseJack)window.DHCCloseJack()}catch(_){}
      j.setAttribute('aria-hidden','true');
    }
  }

  function escapeClose(e){
    if(e.key!=='Escape')return;
    var c=cart();
    if(c&&(c.classList.contains('is-open')||c.getAttribute('aria-hidden')==='false')){
      var close=qs('[data-close-cart-drawer]',c); if(close)close.click();
      return;
    }
    try{if(window.DHCCloseJack)window.DHCCloseJack()}catch(_){}
  }

  function searchLayer(){
    qsa('[data-predictive-search], .predictive-search, .search-modal, [role="dialog"][class*="search"]').forEach(function(el){
      el.style.setProperty('z-index','11050','important');
    });
  }

  function boot(){
    hardenExternalLinks(); syncPanels(); searchLayer();
    document.addEventListener('keydown',escapeClose);
    var c=cart(); if(c)new MutationObserver(syncPanels).observe(c,{attributes:true,attributeFilter:['class','aria-hidden']});
    document.addEventListener('shopify:section:load',function(){hardenExternalLinks();syncPanels();searchLayer()});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
